//import TextBookAddWordPopup from "@/pages/comp/book_order/textbook/popup/add_word";
import TextBookAddWordPopupArea from "@/pages/comp/book_order/textbook/common/popup/add_word";

function TextBookAddWordPopup(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    g_par_id: "",
    g_par_seq: "",
    ...props
  };

  return (
    <div>
      <TextBookAddWordPopupArea
        closePopup={myProps.closePopup}
        refreshData={myProps.refreshData}
        callbackData={myProps.callbackData}
        g_par_id={myProps.g_par_id}
        g_par_seq={myProps.g_par_seq}
      ></TextBookAddWordPopupArea>
    </div>
  );
};
export default TextBookAddWordPopup;